import App from './App.vue';
import { createApp } from 'vue';
import { setupLazyload } from '@star/component';
import { setupI18n } from '@star/languages';
import { setupPinia } from '@star/stores';
import { router } from '@/routers';
import { initApplication } from './initApp';
import 'vant/lib/index.css';
import 'virtual:svg-icons-plugin-register';
import './styles/index.less';

import '@star/styles';
import { emitter, setJSON, setSession } from '@star/utils';
import global from '@/plugins/global';

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

import Image from './components/Image/index.vue';
import CustomEmpty from './components/CustomEmpty.vue';
import GComheader from './components/gComheader/index.vue';

dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

// import VueVideoPlayer from '@videojs-player/vue'
// import 'video.js/dist/video-js.css'

window.G_loginMode = 1; // 默认弹出模式登录
window.$emitter = emitter;

// url参数保存 后续备用
let url_serch = window.location.href.split('?')[1] || '';
url_serch = url_serch.split('#')[0];
if (url_serch) {
  let q = url_serch.split('&');
  let o: any = {};
  for (let i = 0; i < q.length; i++) {
    let item = q[i].split('=');
    o[item[0]] = item[1].replace(/\//g, '');
  }
  setJSON('URI_STR', o, true);
  // 根据url设置主题 优先级最高
  o.theme && setSession('themeName', o.theme);
  // url上的邀请码 //
  o.code && setSession('INVITE_CODE', o.code);
}

(async () => {
  const app = createApp(App);
  app.component('GComheader', GComheader);
  app.component('Image', Image);
  app.component('CustomEmpty', CustomEmpty);

  setupPinia(app);
  // 注册组件
  await initApplication(app);
  await setupI18n(app);
  setupLazyload(app);

  app.use(router);
  app.use(global);
  app.provide('emitter', emitter);
  app.mount('#app');
})();
